import { render, staticRenderFns } from "./LiabilityChartWidget.vue?vue&type=template&id=cd08d1a0&"
import script from "./LiabilityChartWidget.vue?vue&type=script&lang=js&"
export * from "./LiabilityChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports